import React from 'react';
import { InjectedRouter } from 'react-router';

import CoachingViewHeader from 'coaching/components/CoachingViewHeader';
import CoachingHomeView from 'coaching/components/CoachingHomeView/CoachingHomeView';
import CoachingBillingView from 'coaching/components/CoachingBillingView/CoachingBillingView';

import TabPanel from 'components/TabPanel';
import Tabs from 'components/Tabs';

import { GetCoachingHomeDashboard_coaching_getCoachingHomeDashboard } from 'coaching/queries/__generated__/GetCoachingHomeDashboard';

import 'coaching/components/styles/CoachingHomeTabContainer.scss';

export type Props = {
  router: InjectedRouter;
  coachingHomeDashboard: GetCoachingHomeDashboard_coaching_getCoachingHomeDashboard;
  title: string;
};

export const coachingHomeEventPrefix = 'coaching.coaching_home_dashboard';

export default function CoachingHomeTabView(props: Props) {
  const { title, coachingHomeDashboard, router } = props;
  return (
    <div className="CoachingHomeTabContainer">
      <CoachingViewHeader
        imageSize={16}
        textSize="small"
        isTabbed
        title={title}
        helpButtonEventKey={`${coachingHomeEventPrefix}.get_help.click`}
        isCoach
      />
      <Tabs buttonColor="paper" buttonSize="xsmall" type="border">
        <TabPanel className="CoachingHomeTabContainer-tab" title={<span>Home</span>}>
          <CoachingHomeView {...{ coachingHomeDashboard, router }} headerType="none" />
        </TabPanel>
        <TabPanel className="CoachingHomeTabContainer-tab" title={<span>Billing</span>}>
          <CoachingBillingView />
        </TabPanel>
      </Tabs>
    </div>
  );
}
